import React from 'react';
import AccordionCard from '../components/AccordionCard';
import ProductFeaturedFormComponent from '../components/ProductFeaturedFormComponent';
import { patchProductIsFeatured } from '../../../productsActions';
import { connect } from 'react-redux';

function ProductFeaturedContainer({
  selectedProduct,
  patchProductIsFeatured,
  productToggles,
}) {
  return (
    <AccordionCard
      title='Featured - Optional'
      form={
        <ProductFeaturedFormComponent
          patchProductIsFeatured={patchProductIsFeatured}
          {...{ ...productToggles }}
        />
      }
      disabled={false} // Replace with your logic to determine if the form is disabled
      defaultExpanded={true}
    />
  );
}

const mapDispatchToProps = (dispatch) => ({
  patchProductIsFeatured: (isFeatured) =>
    dispatch(patchProductIsFeatured(isFeatured)),
});

const mapStateToProps = (state) => ({
  productToggles: state.productsReducer.productToggles,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductFeaturedContainer);
